export const COLORS = {
  PRIMARY: '#3e8bff',
  DANGER: '#D33535',
  PASS: '#1fa00f',
  WARNING: '#daa13e',
  FAIL: '#e34343',
  GRAY: '#424242',
  LATE_SHORT_COLOR: '#d7a300',
  LATE_LONG_COLOR: '#e53737',
  ON_TIME_COLOR: '#80ca41',

  DARK: '#0e1319',
  DARK_BACKGROUND: '#0b0f14',
  WHITE: '#fff',
  BLACK: '#000',
  LIGHT: '#f7f7f7',
  LIGHT_BACKGROUND: '#f4f4f4',
  LIGHT_BORDER: '#cdd9e9',
  MAIN_GRAY: '#6e767F',
  DARK_BORDER: '#2d343e',
  DARK_GRAY: '#212933',
  DARKER: '#06090c',
  CARD_DARK_GRAY: '#151b23',
  JOBS_BG: '#eceff4',
  CARD_LIGHT_GRAY: '#192029',
  BUTTON_GRAY: '#1a202b',
  GREEN: '#6edc11',
  BUTTON_LIGHT_GRAY: '#27303d',
  SUCCESS: '#43ba01',
  GREEN_LABEL: '#37d187',
  ORANGE: '#dc6226',
  DARK_BLUE_GRAY: '#18212e',
  // My Links new color
  WARNING_BORDER: '#e68b44',
  WARNING_BG: '#151a21',
  PROFILE_BG: '#131a22',
  CHARCOAL_GRAY: '#303946',
  CHARCOAL_BLUE: '#12171f',
  COMPLETENESS_100: '#469c1d',

  // Progress Bar
  DEEP_BLUE_GRAY: '#38485d',
  COOL_TONED_GRAY: '#edf1f6',

  //MODAL Color
  MODAL_DARK: '#0B1017',

  //Not in Figma
  DARK_LIGHT: '#0d1117',
  OFF_WHITE: '#f1f1f1',
  DARK_WHITE: '#d5dbe3',
};
